/*
 * Copyright (c) 2024. Tooling Team
 */

import { MintHeader } from "../navigation/MintHeader";
import { MintFooter } from "../navigation/MintFooter";
import PropTypes from "prop-types";

// Default header and footer
const Layout = ({ children }) => {
  return (
    <>
      <MintHeader />
      <main>{children}</main>
      <MintFooter />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default Layout;
